// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"65908674","977":"771c2437"}[chunkId] + ".chunk.js";
};